<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}">
    <div class="position: relative;">
      <!-- .custom-company-cooperation === ccc -->
      <div class="ccc">
        <div class="ccc-box custom-item">
          <!-- 内容 -->
          <div class="custom-m-item">
            <div class="cmi-header">
              <div class="cmi-header-lgoo">
                <img :src="Modal.logo" v-if="Modal && Modal.logo" />
                <!-- <img :src="company.logo" v-else /> -->
              </div>
              <img src="@assets/img/template/company-component-coveEn-1.jpg" width="100%" />
              <!-- {{Modal}} -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  // 顶部banner
  name: "custom-company-header",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() { 
        return null;
      }
    }
  },
  data() {
    return {
      uploadChooseShowed: false, // 控制文件上传方式的显示和隐藏
      visible: false,

      imgName: "",
      defaultList: [],
      visible2: false,
      uploadList: []
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      // if (val !== this.index) this.visible = false;
    },
    save(val, oldVal) {
      if (val) {
        this.handleSubmit();
        this.visible = false;
      }
    }
  },
  computed: {
    ...mapGetters({
      activeIndex: "customCompanyModule/getActiveIndex",
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      save: "customCompanyModule/getSave"
    }),
    type() {
      return this.Modal.config.type;
    }
  },
  mounted() {
    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations({
      setCompany: "loginModule/setCompany",
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }),
    ...mapActions({
      getCompanyById: "loginModule/getCompanyById",
      editCompany: "companyModule/editCompany"
    }),
    init() {
      this.defaultList = [
        {
          name: this.company.name,
          url: this.company.logo,
          status: "finished",
          percentage: 100
        }
      ];
      this.uploadList = this.defaultList;
    },
    // 选择图片上传方式
    selectType() {
      this.uploadChooseShowed = true;
    },
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 1) {
          this.$Message.warning(`Upload one image only`);
          return;
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
          this.uploadChooseShowed = false;
        }
      }
    },
    // 上传图片
    handleView(name) {
      this.imgName = name;
      this.visible2 = true;
    },
    handleRemove(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList = [];
      this.defaultList = [];
      this.uploadList = [];
    },
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError(file) {
      this.$Notice.warning({
        title: "Incorrect file format",
        desc: "Upload image in jpg/png format"
      });
    },
    handleMaxSize(file) {
      this.$Notice.warning({
        title: "File size exceeds configured limit",
        desc: "Upload image size less than 2M"
      });
    },
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Notice.warning({
          title: `Upload ${limitNum} image only`
        });
      }
      return check;
    },
    async handleSubmit(name) {
      let logo = "";
      if (this.uploadList && this.uploadList.length) {
        logo = this.uploadList[0].url;
      } else {
        this.$Message.error("请上传公司logo");
        return;
      }
      let req = {
        Id: this.company.id,
        SetValues: {
          Logo: logo
        }
      };
      const bool = await this.editCompany(req);
      if (!bool) {
        return false;
      }
      if (bool.errors && bool.errors[0]) {
        this.$Message.error(bool.errors[0].description);
        return;
      }
      let company = await this.getCompanyById(this.company.id);
      this.setCompany(company);
      this.init();
    }
  }
};
</script> 
<style scoped lang="scss">
.ccc {
  width: 100%;
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  &-poptip {
    min-height: 60px;
    .cccp {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-content {
        padding: 40px 50px;
        .addlink {
          border: dashed 1px #bfbfbf;
          text-align: center;
          color: #1890ff;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}

.custom-m-item {
  background: #fff;
  position: relative;
  .cmi-header-lgoo {
    position: absolute;
    top: 10px;
    left: 7px;
    width: 30px;
    height: 30px; 
    border-radius: 5px; 

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
